import { Title } from '..'

import { Subtitle, Tag } from './components'

import styles from './SectionHeader.module.scss'

export const SectionHeader = ({ tagText, tagBackground, title, subtitle }) => {
  return (
    <>
      <Tag text={tagText} bgColor={tagBackground} />

      <Title text={title} customClass={styles.sectionHeader__title} />

      {subtitle && (
        <Subtitle
          text={subtitle}
          customClass={styles.sectionHeader__subtitle}
        />
      )}
    </>
  )
}
